/**
 * api接口的统一出口
 */
// 客户工作台模块接口
import client from "@/api/client";
// 登录注册模块接口
import user from "@/api/user";
// 承运商模块接口
import carrier from "./carrier";
// 供应商模块接口
import supplier from "./supplier";
// 二次开发接口
import twice from "./twice";
// 物资供应链
import materialSupply from "./materialSupply";

import captcha from "./captcha";
// 导出接口
export default {
  client,
  user,
  carrier,
  supplier,
  twice,
  materialSupply,
  captcha,
};
